import { Button } from "react-aria-components";
import { globalSubmittingSignal } from "../../Layout";
import * as Navigation from "../../../../../modules/Navigation";
import { useNavigate } from "react-router";

interface IEditActionProps {
    id: string,
    entityName: string,
    displayText?: string,
    parentEntityId?: string | undefined,
    parentEntityName?: string | undefined,
}

export default function EditAction(props: IEditActionProps) {
    const navigate = useNavigate();
    const { id, entityName, displayText, parentEntityId, parentEntityName } = props;

    function handleEdit() {
        if (parentEntityId && parentEntityName) {
            Navigation.editWithParent.navigate(navigate, entityName, id, parentEntityName, parentEntityId);
        } else {
            Navigation.edit.navigate(navigate, entityName, id);
        }
    }

    return <Button isDisabled={globalSubmittingSignal.value.isBusy} className="button button--small button--primary button--with-icon" onPress={handleEdit}>
        <p className="button-text">{displayText ?? 'Edit'}</p>
    </Button>
}